/* eslint-disable max-len */
import {
  Component, ComponentInterface, Element, h, Host, Prop,
} from '@stencil/core';
import { versionComponent } from '../../global/inject-dependencies';

@Component({
  tag: 'ui-headline',
  styleUrl: 'ui-headline.scss',
  shadow: true,
})
export class UiHeadline implements ComponentInterface {
  @Element() el: HTMLElement;

  /**
   * @desciption The *level* property reflects the headline's hierarchy in the page or component that is inserted into. There are 6 levels, the highest is 1 and the lowest 6.
   */
  @Prop({ reflect: true }) level: number;

  /**
   * Adds an icon before the headline's text.
   */
  @Prop() icon: string;

  /**
   * Checks whether headline is centered on the component or not.
   */
  @Prop({ attribute: 'is-headline-centered' }) isCentered: boolean;

  /**
   * Relates to the icon's appearance, when it is present. The default value is *white*.
   */
  @Prop({ reflect: true }) iconVariant: 'white';

  /**
   * Property used by the superteaser component to style headline according to that component's style. Only used for that context.
   */
  @Prop({ reflect: true }) conversion: 'superteaser';

  render() {
    const HeadlineTag = `h${this.level}`;

    return (
      <Host>
        <HeadlineTag
          class={{
            'ui-headline': true,
            [`ui-headline--${this.level}`]: true,
            'ui-headline--centered': this.isCentered,
          }}
          part="headline"
        >
          {this.icon && <ui-icon icon={this.icon} variant={this.iconVariant}></ui-icon>}
          <slot></slot>
        </HeadlineTag>
      </Host>
    );
  }
}

versionComponent(UiHeadline);
